// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3SuQS","alert":"SettungsInbox_alert__2MxKE"};